<template>
  <div>
    <v-data-table
      :items="coils"
      :headers="headers"
      hide-default-footer
      hide-default-header
      class="coil-table"
      :items-per-page="-1"
      mobile-breakpoint="0"
    >
      <template v-slot:item="{ item }">
        <tr
          pt-2
          mb-2
          :class="{
            'yellow lighten-3': item.active && showActionText(item) && !showChangeProductAfterSoldOutText(item),
            'green lighten-3': item.active && showActionText(item) && showChangeProductAfterSoldOutText(item),
            'red lighten-2': !item.active
          }"
        >
          <td style="width: 90px">
            {{ item.label }}
            <label class="caption">
              <strong :class="{
                'red--text': (
                  getCoilHeight(locationData.coil_settings, item.label, isDrinkMachine(locationData.machine_model)) === '高' ||
                  getCoilHeight(locationData.coil_settings, item.label, isDrinkMachine(locationData.machine_model)) === '全'
                ),
                'blue--text': (
                  getCoilHeight(locationData.coil_settings, item.label, isDrinkMachine(locationData.machine_model)) === '低' ||
                  getCoilHeight(locationData.coil_settings, item.label, isDrinkMachine(locationData.machine_model)) === '半'
                ),
                'green--text': getCoilHeight(locationData.coil_settings, item.label, isDrinkMachine(locationData.machine_model)) === '小'
              }">
                {{ getCoilHeight(locationData.coil_settings, item.label, isDrinkMachine(locationData.machine_model)) }}
              </strong>
            </label>
          </td>
          <td style="width: 100px">{{ item.stock }} / {{item.capacity}}</td>
          <td>
            <span v-if="showActionText(item)">
              <v-tooltip bottom class="product-action">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-icon
                      v-if="showChangeProductAfterSoldOutText(item)"
                      small
                    >history</v-icon>
                    <span
                      v-if="showChangeProductAfterSoldOutText(item)"
                    >清貨中！不需補貨！售罊後</span>
                    <span v-if="showRemoveProductText(item)">移除貨品</span>
                    <span
                      v-if="showChangeCoilText(item)"
                    >換 {{ item.coilObject.product.coil_number || '-' }} coil, </span>
                    <span
                      v-if="showChangeProductText(item)"
                    >換貨 {{ item.coilObject.product.name_zh_hk }} {{item.coilObject.product.size || ''}}</span>
                  </div>
                </template>

                <div class="product-action-tooltip">
                  <span class="product-action-tooltip-name">
                    Edited by
                    <span
                      class="name-string"
                    >{{ getEditorName(item.coilObject) }}</span>
                  </span>
                  <span
                    class="product-action-tooltip-time"
                  >{{ unixTimestampToFromNow(item.coilObject.updated_at) }}</span>
                  <div class="product-action-tooltip-remarks">
                    Remarks:
                    <span
                      class="remarks-string"
                    >{{ item.coilObject.remarks || '/' }}</span>
                  </div>
                </div>
              </v-tooltip>
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import dateMixin from '@/mixins/date'
  import coilSettingMixin from '@/mixins/coilSetting'

  export default {
    props: {
      product: Object,
      locationData: Object,
      allProducts: Array
    },

    mixins: [
      dateMixin,
      coilSettingMixin
    ],

    components: {
    },

    data () {
      return {
        headers: [
          { text: 'Coil', align: 'left', sortable: false, width: '90px' },
          { text: 'Stock', align: 'left', sortable: false, width: '100px' },
          { text: 'Action', align: 'left', sortable: false }
        ],

        dataPointInterval: 6,
        editingCoilIndex: null,
        editProductDialog: false,
        editingCoil: null,
        coils: []
      }
    },

    created () {
      this.coils = this.product.coils
    },

    computed: {
      isOldSeries () {
        const oldSeries = ['H3', 'H4']
        // negative if no machine model is set
        return this.locationData.machine_model && oldSeries.some(series => this.locationData.machine_model.toUpperCase().startsWith(series))
      }
    },

    methods: {
      expiredIn () {
        return this.daysToGo(this.product.location_product.expired_at)
      },

      editProduct (label) {
        let i = 0
        let index = -1
        this.coils.forEach((coil) => {
          if (coil.label === label) {
            index = i
          }
          i++
        })
        this.editingCoil = this.coils[index].coilObject
        this.editingCoilIndex = index
        this.editProductDialog = true
      },

      switchProduct (data) {
        this.coils[this.editingCoilIndex].coilObject = data
        this.editingCoilIndex = null
        this.editProductDialog = false
      },

      getEditorName (coil) {
        if (typeof coil.user === 'undefined' || !coil.user) {
          return 'anonymous'
        }

        return coil.user.display_name
      },

      showActionText (coil) {
        return false && (
          coil.coilObject.is_enabled &&
          (
            this.showChangeCoilText(coil) ||
            this.showChangeProductText(coil) ||
            this.showRemoveProductText(coil)
          )
        )
      },

      showRemoveProductText (coil) {
        return !coil.coilObject.product && this.product.id
      },

      showChangeCoilText (coil) {
        return (
          !this.isOldSeries &&
          coil.coilObject.product &&
          parseInt(coil.capacity) !== parseInt(coil.coilObject.product.coil_number)
        )
      },

      showChangeProductText (coil) {
        return (
          (coil.coilObject.product && this.product.id !== coil.coilObject.product.id)
        )
      },

      showChangeProductAfterSoldOutText (coil) {
        return (
          this.showChangeProductText(coil) &&
          !coil.coilObject.is_change_now &&
          coil.stock > 0 &&
          (!this.product.expired_at || this.expiredIn() > 0)
        )
      }

    }
  }
</script>

<style lang="stylus" scoped>
  .product-action
    cursor: default

  .product-action-tooltip
    font-size: 14px

  .product-action-tooltip-name
    margin: auto
    padding-right: 20px

  .product-action-tooltip-time
    margin: auto
    float: right
    font-size: 12px

  .name-string
    color:yellow

  .remarks-string
    color:yellow

  .product-image
    width: 90px
    height: 90px

    img
      width: 100%
      height: 100%
      object-fit: contain
</style>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Products/LocationProduct/CoilTable.vue